import {
  ADMIN_SCORE_FETCH_ALL,
  ADMIN_SCORE_FETCH_ALL_SUCCESS,
  ADMIN_SCORE_FETCH_ALL_FAIL,
  ADMIN_SCORE_FETCH,
  ADMIN_SCORE_FETCH_SUCCESS,
  ADMIN_SCORE_FETCH_FAIL,
  ADMIN_SCORE_UPDATE,
  ADMIN_SCORE_UPDATE_SUCCESS,
  ADMIN_SCORE_UPDATE_FAIL,
  ADMIN_SCORE_SET_SORT
} from './constants';
import { createSelector } from 'reselect';
import defaultScores from './defaultScores';

const initialState = {
  fetching: false,
  fetched: false,
  scores: defaultScores,
  sortAttribute: 'name',
  sortAttributeInverted: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_SCORE_FETCH_ALL:
      return { ...state, fetching: true };
    case ADMIN_SCORE_FETCH_ALL_SUCCESS: {
      const scores = {};
      action.scores.forEach(score => {
        scores[score.id] = score;
        scores[score.id].saved = true;
      });
      return { ...state, fetching: false, fetched: true, scores };
    }
    case ADMIN_SCORE_FETCH_ALL_FAIL:
      return { ...state, fetching: false };
    case ADMIN_SCORE_FETCH:
      return { ...state, fetching: true };
    case ADMIN_SCORE_FETCH_SUCCESS: {
      const scores = JSON.parse(JSON.stringify(state.scores));
      scores[action.score.id] = action.score;
      scores[action.score.id].saved = true;
      return { ...state, scores };
    }
    case ADMIN_SCORE_FETCH_FAIL:
      return { ...state, fetching: false };
    case ADMIN_SCORE_UPDATE: {
      const scores = JSON.parse(JSON.stringify(state.scores));
      scores[action.score.id] = action.score;
      scores[action.score.id].saving = true;
      return { ...state, scores };
    }
    case ADMIN_SCORE_UPDATE_SUCCESS: {
      const scores = JSON.parse(JSON.stringify(state.scores));
      scores[action.score.id].saved = true;
      delete scores[action.score.id].saving;
      return { ...state, scores };
    }
    case ADMIN_SCORE_UPDATE_FAIL: {
      const scores = JSON.parse(JSON.stringify(state.scores));
      delete scores[action.score.id].saving;
      return { ...state, scores };
    }
    case ADMIN_SCORE_SET_SORT: {
      const sortAttributeInverted =
        state.sortAttribute === action.sort ?
          !state.sortAttributeInverted : false;
      return { ...state, sortAttribute: action.sort, sortAttributeInverted };
    }
  }
  return state;
};

const fetching = state => state.scoreAdmin.fetching;
const fetched = state => state.scoreAdmin.fetched;
const scores = state => state.scoreAdmin.scores;
const sortAttribute = state => state.scoreAdmin.sortAttribute;
const sortAttributeInverted = state => state.scoreAdmin.sortAttributeInverted;

export const isFetchingScores = createSelector(
  fetching, fetching => fetching
);

export const hasFetchedScores = createSelector(
  fetched, fetched => fetched
);

export const getSavedScores = createSelector(
  scores, scores => Object.values(scores).filter(score => score.saved)
);

export const getScores = createSelector(
  [getSavedScores, sortAttribute, sortAttributeInverted],
  (scores, attribute, inverted) => {
    return [ ...scores ].sort((a, b) => {
      if (a[attribute] < b[attribute]) return inverted ? 1 : -1;
      if (a[attribute] > b[attribute]) return inverted ? -1 : 1;
      return 0;
    });
  }
);

export const getScoresObj = createSelector(
  scores, scores => scores
);

export const getScoreCount = createSelector(
  getScores, scores => scores.length
);

export const getScoreSortAttribute = createSelector(
  sortAttribute, sort => sort
);

export const getScoreSortAttributeInverted = createSelector(
  sortAttributeInverted, inverted => inverted
);

export const getScoreDefinitions = createSelector(
  getScoresObj, scores => {
    const scoreDefinitions = {};
    const ids = Object.keys(scores);
    for (let i = 0; i < ids.length; i++) {
      const score = scores[ids[i]];
      delete score.id;
      scoreDefinitions[score.key] = score;
    }
    return scoreDefinitions;
  }
);

export default reducer;
